module.exports = __webpack_public_path__ + "static/media/info.019d47a6.svg";